export default __webpack_public_path__ + "static/media/Andrew Friedson.e67fd57f.png";